// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"d6c97d35","902":"94537dba","979":"c342b939"}[chunkId] + ".chunk.js";
};